import { DeviceRegistrationPage } from "fleet/view/device/new";
import { connect } from "react-redux";
import { makeGetAllAsArray } from "redux-store";
import { createPromiseApiAction } from "redux-store/api-sagas";
import { getVistarAccountIds } from "redux-store/auth";
import { getAllDevicesTags } from "redux-store/devices";
import { NEW_DEVICE } from "redux-store/devices/actions";
import { addErrorMessageAction } from "redux-store/messages";
import { networksSelector } from "redux-store/networks";
import { LOAD_VISTAR_VENUES } from "redux-store/vistar-accounts/actions";

const getAllDevicesAsArray = makeGetAllAsArray();

function mapStateToProps(state) {
  const devices = getAllDevicesAsArray(state.global.devices);
  const deviceTags = getAllDevicesTags(devices);
  const vistarAccountIds = getVistarAccountIds(state);

  return {
    deviceTags,
    networks: networksSelector(state),
    vistarAccountIds,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    addErrorMessage: (message) => {
      dispatch(addErrorMessageAction(message));
    },
    addNewDevice: (serviceArgs) => {
      const {
        deviceName,
        isAgent,
        location,
        networkId,
        partnerVenueId,
        registrationCode,
        tags,
      } = serviceArgs;

      return createPromiseApiAction(dispatch, NEW_DEVICE, [
        registrationCode,
        deviceName,
        networkId,
        tags,
        partnerVenueId,
        location,
        isAgent,
      ]);
    },
    getVistarVenues: (networkId) => {
      return createPromiseApiAction(dispatch, LOAD_VISTAR_VENUES, [networkId]);
    },
  };
}

const ConnectedDeviceRegistrationPage = connect(
  mapStateToProps,
  mapDispatchToProps,
)(DeviceRegistrationPage);

export { ConnectedDeviceRegistrationPage };
